import makeStyles from "utils/makeStyles";

export default makeStyles({
  header: {
    padding: "18px 20px 10px",
  },
});
